import { action } from 'typesafe-actions';
import { Network } from '@kattana-io/common';

const entity = 'network';
const SET_NETWORK = `${entity}/SET_NETWORK`;

const actionSetNetwork = (network: Network) =>
  action(SET_NETWORK, network);

export { SET_NETWORK, actionSetNetwork };
